import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { trackEvent } from "../lib/seo";
import PricingHero from "../sections/PricingHero";
import PlanCards from "../sections/PlanCards";
import HowPricingWorks from "../sections/HowPricingWorks";
import ComparisonTable from "../sections/ComparisonTable";
import PricingFaq from "../sections/PricingFaq";
import PricingTrustNote from "../sections/PricingTrustNote";
import PricingCta from "../sections/PricingCta";

const PRICING_SEO =
    "BuildEase pricing: pay once per project. Free, Standard R1,499, Premium R3,499.";

const PricingPage = () => {
    useEffect(() => {
        trackEvent("pricing_view");
    }, []);

    return (
        <div className="min-h-screen bg-ink text-white">
            <Seo title={PRICING_SEO} description={PRICING_SEO} />
            <Navbar />
            <main>
                <PricingHero />
                <PlanCards />
                <HowPricingWorks />
                <ComparisonTable />
                <PricingFaq />
                <PricingTrustNote />
                <PricingCta />
            </main>
            <Footer />
        </div>
    );
};

export default PricingPage;
